import { useNavigate } from "react-router-dom";
import logo from "../../images/logo_horizontal.svg";
import { useAuth } from "../../context/useAuth";
import { useEffect, useState } from "react";
import { Sidebar as SidebarCommon } from "@tw/tw-common-js";
import { useVisibility } from "../../context/useVisibility";
import api from "../../services/api";

export default function Sidebar({ sidebarVisible }) {
  const { checkPrivileges, logout, user } = useAuth();
  const { pinnedTabs, savePinnedTabs } = useVisibility();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user?.id) return;

    setItems([
      {
        label: "Org Chart",
        icon: "account_tree",
        to: "/orgchart",
        show: checkPrivileges("viewOrgChart"),
      },
      {
        label: "Teammates",
        icon: "person",
        to: "/person",
        show: checkPrivileges("viewTeammateList"),
      },
      {
        label: "Settings",
        icon: "settings",
        to: "/settings",
        submenu: [
          {
            label: "Users",
            to: "/user",
            show: checkPrivileges("editUser"),
          },
          { label: "Roles", to: "/settings/roles", show: checkPrivileges("editRoles") },
        ],
      },
    ]);
  }, [user?.id]);

  return (
    <>
      <SidebarCommon
        items={items}
        sidebarVisible={sidebarVisible}
        pinnedTabs={pinnedTabs}
        savePinnedTabs={savePinnedTabs}
        getProfileImgThumb={api.getProfileImgThumb}
        logout={logout}
        user={user}
        logo={logo}
        logoText="THE BOS"
        handleLogout={logout}
        openProfile={() => navigate("/profile")}
      ></SidebarCommon>
    </>
  );
}
